module.exports = __webpack_public_path__ + "static/media/QUIQspread.4121ed65.svg";


//////////////////
// WEBPACK FOOTER
// ./src/login/QUIQspread.svg
// module id = 2360
// module chunks = 0